import React, { useEffect, useState } from "react";
import "./snapshot.css";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Form, Input, Nav, NavItem, NavLink } from "reactstrap";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { DepartmentOptions, columnOptions, yesNoOptions } from "../patient/Constant";
import { getPatients, updatePatientById } from "../../api/patient";
import { decryptData } from "../../utils/helper";
import { failed, success } from "../../utils/Tostify";
import { calculateAge } from "../../utils/DateSupport";
import Search from "../../components/InputFields/Search";
import { AI_CARE, ITEMS_PER_PAGE } from "../../utils/constants";
import { applyFilters, decryptPatientData } from "../../utils/common";
import CustomPagination from "../../components/Pagination/CustomPagination";
import MultiSelectCheckbox from "../../components/InputFields/MultiSelectWithCheckboc";
import moment from "moment";
import { FormControl, MenuItem, Select} from "@mui/material";
import TextInput from "../../components/InputFields/TextInput";
import { Link, useNavigate } from "react-router-dom";
import { getStaffsByOrgId } from "../../api/User";
import { useConfirmDialog } from "../../hooks/useConfirmDialog";
import Loader from "../../components/Loader/Loader";
import { getAllApplication, updateApplicationById } from "../../api/Applications";
import Stepper from "react-stepper-horizontal";
import {  columnApplicationOptions } from "../applications/Constant";
import { deleteFilter } from "../../api/filters";
import DynamicFilterDropdown from "../../components/Filters/Filter";
import noProfileImg from "../../../src/assets/images/noImage.jpg";
function snapshot({ direction, ...args }) {
  const navigate = useNavigate();
  // localStorage.setItem("prevRoute", window.location.pathname);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [expandedOrg, setExpandedOrg] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState(columnOptions.filter(option => option.value !== "discharged_status" && option.value !== "stage").map(option => option.value));
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  let token = useSelector(state => state.userReducer.token);
  const dispatch = useDispatch();
  const [patients, setPatients] = useState([]);
  const [listFilter, setListFilter] = useState("new");
  const [filteredPatients, setFilteredPatients] = useState([]);
  const [houseIncome, setHouseIncome] = useState({});
  const [staffList, setStaffOptions] = useState([]);
  const [editingPatient, setEditingPatient] = useState({});
  const { getConfirmation } = useConfirmDialog();
  const [patientNote, setNote] = useState('');
  const [countofList, setCountOfList] = useState();
  const [countofApplicationList, setCountOfApplicationList] = useState();
  const [dropdownState, setDropdownState] = useState({});
  const [selectedFilter, setSelectedFilter] = useState([]);
  const [sortBy, setSortBy] = useState({
    column: "",
    desc: false
  });
  const [searchKey, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage] = useState(ITEMS_PER_PAGE);
  //Applications
  const [applicationList, setApplicationlist] = useState([]);
  const [filteredApplications, setFilteredApplication] = useState([]);
  const [applicationNote, setApplicationNote] = useState('');
  const handleColumn = (event) => {
    setSelectedOption(event.target.value);
  };
  const [initialHouseIncome, setInitialHouseIncome] = useState({});

  const togglefour = (filterId) => {
    setDropdownState((prevState) => ({
      ...prevState,
      [filterId]: !prevState[filterId]
    }));
  };


  const getPatientList = async () => {
    let res;
    try {
      setIsLoading(true);
      res = await getPatients({ dispatch, token, listFilter, orgId : localStorage.getItem("currentOrgId"), clinicId : localStorage.getItem("currentHospitalId") });
      if (res?.status === "SUCCESS") {
        const responseData = decryptData(res.data);
        setCountOfList(responseData?.filterCounts);
        if (responseData?.list) {
          const decryptedPatients = await Promise.all(
            responseData.list?.map(async (patient) => {
              return decryptPatientData(patient);
            })
          );
          setPatients({ ...responseData, items: decryptedPatients });
        }
        setIsLoading(false);
      }
    } catch (error) {
      failed(res?.message);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const lowercasedSearchKey = searchKey?.trim()?.toLowerCase();

    if (!lowercasedSearchKey) {
      // No search key, reset to original data
      listFilter !== "applications" && listFilter !== "apln-assigned-me"
        ? setFilteredPatients(patients?.items)
        : setFilteredApplication(applicationList?.list?.items);
      return;
    }

    if (listFilter !== "applications" && listFilter !== "apln-assigned-me") {
      const filteredPatients = patients?.items?.filter((patient) => {
        const patientName = patient?.name?.text?.toLowerCase();
        const patientTelecom = patient?.telecom?.map(t => t?.value.toString().toLowerCase()).join(" ");
        const patientLocationCity = patient?.address?.city?.toLowerCase();
        const patientLocationState = patient?.address?.state?.toLowerCase();

        return (
          patientName.includes(lowercasedSearchKey) ||
          patientTelecom.includes(lowercasedSearchKey) ||
          patientLocationCity.includes(lowercasedSearchKey) ||
          patientLocationState.includes(lowercasedSearchKey)
        );
      });

      setFilteredPatients(filteredPatients);
    } else {
      const filteredApplications = applicationList?.list?.items?.filter((apln) => {
        const aplnName = apln?.title?.toLowerCase();
        return aplnName.includes(lowercasedSearchKey);
      });
      setFilteredApplication(filteredApplications);
    }
  }, [searchKey, patients, applicationList, listFilter]);

  const handleExpand = (id) => {
    setExpandedOrg(prev => prev.includes(id) ? prev.filter(orgId => orgId !== id) : [...prev, id]);
  };
  const handleSort = (column) => {
    setSortBy((prevSortBy) => ({
      column,
      desc: column === prevSortBy.column ? !prevSortBy.desc : false
    }));

    const sortDirection = sortBy.desc ? 1 : -1;

    if (listFilter !== "applications" && listFilter !== "apln-assigned-me") {
      // Sorting for patients
      const sortedPatients = [...filteredPatients].sort((a, b) => {
        const nameA = a.name?.text?.toLowerCase();
        const nameB = b.name?.text?.toLowerCase();
        return nameA.localeCompare(nameB) * sortDirection;
      });
      setFilteredPatients(sortedPatients);
    } else {
      // Sorting for applications
      const sortedApplications = [...filteredApplications].sort((a, b) => {
        const titleA = a.title?.toLowerCase();
        const titleB = b.title?.toLowerCase();
        return titleA.localeCompare(titleB) * sortDirection;
      });
      setFilteredApplication(sortedApplications);
    }
  };

  const handleSearch = (e) =>{
    setSearch(e.target.value);
    setCurrentPage(1);
  };

  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const paginatedPatients = filteredPatients?.slice(startIndex, endIndex);
  const handlePagination = (page) => {
    setCurrentPage(page);
  };

  const getStaffList = async (page, limit, searchKey = "") => {
    let res;
    try {
      setIsLoading(true);
        res = await getStaffsByOrgId({dispatch, token, page, limit, searchKey, orgId: localStorage.getItem("currentOrgId"), currentHospitalId : localStorage.getItem("currentHospitalId")});
      const responseData = decryptData(res?.data);
      if (res?.status === "SUCCESS") {
        const dropdownData = responseData?.items?.map((staff) => ({
          label: `${staff.firstName} ${staff.lastName}`,
          value: staff._id
        }));
        setStaffOptions(dropdownData);
        setIsLoading(false);
      }
    } catch (error) {
      failed(res?.message);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getStaffList();
  }, []);

  const handleStaffSelect = async (patientId, value) => {
    let res;
    try {
      const payload = { patientId, staffId: value };
      setIsLoading(true);
      res = await updatePatientById({ payload, dispatch, token, patientId });
      if (res?.status == "SUCCESS") {
        setIsLoading(false);
        await getPatientList();
        success(res?.message);
      } else {
        setIsLoading(false);
        failed(res?.message);
      }
    } catch (error) {
      setIsLoading(false);
      failed(res?.message);
    }
  };

  useEffect(() => {
    const initialIncome = {};
    filteredPatients?.forEach((patient) => {
      initialIncome[patient._id] = patient.houseHoldIncome;
    });
    setInitialHouseIncome(initialIncome);
    setHouseIncome(initialIncome);
  }, [filteredPatients]);

  const handleSaveClick = async (patientId, payload) => {
    // ✅ Skip householdIncome comparison if it's not part of the payload
    if (
      Object.prototype.hasOwnProperty.call(payload, "houseHoldIncome") &&
      initialHouseIncome[patientId] === payload.houseHoldIncome
    ) {
      if (Object.keys(payload).length === 1) {
        return;
      }
    }
    let res;
    try {
      setIsLoading(true);
      res = await updatePatientById({ payload, dispatch, token, patientId });
      if (res?.status === "SUCCESS") {
        await getPatientList();
        setIsLoading(false);
        success(res?.message);
        setEditingPatient(false);
      } else {
        setIsLoading(false);
        failed(res?.message);
      }
    } catch (error) {
      failed(res?.message);
      setIsLoading(false);
    }
  };
  const handleHouseIncomeChange = (patientId, value) => {
    // If the input is cleared, set the value to 0
    const numericValue = value === "" ? "" : Number(value);
    if (!isNaN(numericValue) && numericValue >= 0) {
      setHouseIncome((prevState) => ({
        ...prevState,
        [patientId]: numericValue
      }));
    }
  };

  const handleNoteChange = (patientId, value) => {
    setNote((prevState) => ({ ...prevState, [patientId]: value })); // Update note text for specific patient
  };

  const handleDeleteClick = async (patientId, payload) => {
    let res;
    try {
      const confirmed = await getConfirmation({
        title: "Attention!",
        entryName: "",
        actionBtnTitle: "Yes",
        message: `Are you sure want to Delete Note`
      });
      if (confirmed) {
        setIsLoading(true);
        res = await updatePatientById({ payload, dispatch, token, patientId });
        if (res?.status === "SUCCESS") {
          await getPatientList();
          setIsLoading(false);
          success(res?.message);
          setEditingPatient(false);
        } else {
          setIsLoading(false);
          failed(res?.message);
        }
      }
    } catch (error) {
      failed(res?.message);
      setIsLoading(false);
    }
  };

  const handleEditClick = (patientId) => {
    setEditingPatient((prevState) => ({ ...prevState, [patientId]: true })); // Enable editing mode for specific patient
  };

  const handleFilter = (status) => {
    setListFilter(status);
  };


  useEffect(() => {
      getPatientList();
      getApplicationList();
      if(listFilter === "applications" || listFilter === "apln-assigned-me"){
       setSelectedOption(columnApplicationOptions.map((option) => option.value));
      }else{
        setSelectedOption(columnOptions.filter(option => option.value !== "discharged_status" && option.value !== "stage").map((option) => option.value));
      }
  }, [listFilter]);

  //Applications

  const getApplicationList = async (page, limit, searchKey = "") => {
    let res;
    let filter = listFilter === "applications" ? "all" : "assigned-me";
    try {
      setIsLoading(true);
      setSearch(searchKey);
      res = await getAllApplication({
        dispatch,
        token,
        listFilter : filter,
        clinicId : localStorage.getItem("currentHospitalId")
      });
      const responseData = decryptData(res?.data);
      if (res?.status === "SUCCESS") {
        setApplicationlist(responseData);
        setCountOfApplicationList(responseData?.filterCounts);
        setFilteredApplication(responseData?.list?.items);
        setIsLoading(false);
      }
    } catch (error) {
      failed(res?.message);
      setIsLoading(false);
    }
  };

  const handleUpdate = async (aplnId, payload) => {
    let res;
    try {
      setIsLoading(true);
      res = await updateApplicationById({ payload, dispatch, token, aplnId });
      const responseData = decryptData(res.data);
      if (res?.status == "SUCCESS") {
        setIsLoading(false);
        await getApplicationList();
        success(res?.message);
      } else {
        setIsLoading(false);
        failed(res?.message);
      }
    } catch (error) {
      setIsLoading(false);
      failed(res?.message);
    }
  };

  const applyPatientFilters = (filters) => {
    let result = patients?.items;
    const filteredPatients = applyFilters(filters, result, "Patient");
    setFilteredPatients(filteredPatients);
  };

  const applyApplicationFilters = (filters) => {
    let result = applicationList?.list?.items;
    const filtered = applyFilters(filters, result, "Application");
    setFilteredApplication(filtered);
  };

  const handleFilterSelect = (filter) => {
    const newFilters = filter.filters;
    {listFilter !== "applications" && listFilter !== "apln-assigned-me" ?
    applyPatientFilters(newFilters) :
    applyApplicationFilters(newFilters);}
    setSelectedFilter(newFilters);
  };

  const paginatedApplications = filteredApplications?.slice(
    startIndex,
    endIndex
  );

  const  handleFilterDelete  = async(id) =>{
    const confirmed = await getConfirmation({
      title: "Attention!",
      entryName: "",
      actionBtnTitle: "Yes",
      message: `Are you sure you want to delete Filter?`
    });
    if (confirmed) {
        let res;
        try {
            const values = {filterId: id};
            setIsLoading(true);
            res = await deleteFilter({values, dispatch, token});
            if (res?.status === "SUCCESS") {
                setIsLoading(false);
                await getPatientList();
                success(res?.message);
            } else {
                setIsLoading(false);
                failed(res?.message);
            }
        } catch (error) {
            setIsLoading(false);
            failed(res?.message);
        }
      }
    };

  const isPatient = listFilter !== "applications" && listFilter !== "apln-assigned-me";

   const getRelationshipWithAges = (members) => {
    if (!members || members.length === 0) return '';
    return members.map((member, idx) => {
      const dob = member.dob;
      const relationship = member.relationship || "Member";
      if (!dob) return <div key={idx}>{relationship}: N/A</div>;
      const age = calculateAgeFormatted(moment(dob, "MM-DD-YYYY").toDate());
      return (
        <div key={idx}>
          {relationship}: {age}
        </div>
      );
    });
  };

   const calculateAgeFormatted = (dob) => {
    const now = moment();
    const birth = moment(dob);
    const years = now.diff(birth, 'years');
    if (years === 0) return "less than one year";
    return `${years} years`;
  };

  useEffect(() => {
    localStorage.setItem("prevRoute", window.location.pathname);
  }, []);

  return (
    <>
      <div className="dashboard_container table_listing_color">
      {isLoading ? <Loader /> : null}
        <div className="d-flex justify-content-between align-items-center main-header-block">
          <div className="left_header d-flex align-items-center justify-content-between">
            <h2 className="home-title">Snapshot</h2>
            <div className="drop_block">
              <Dropdown isOpen={dropdownOpen} toggle={toggle} direction={direction}>
                <DropdownToggle className="filter_block_blk" size="xl" caret>
                  <i className="fa fa-ellipsis-v"></i>
                </DropdownToggle>
                <DropdownMenu {...args}>
                  <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={()=> navigate("/app/start-application")}>
                    <button
                      className="dash_button"
                      onClick={() => {
                        const prevRoute = localStorage.getItem("prevRoute");
                        // console.log("Previous Route before navigating:", prevRoute);
                        const isRouteMode3 = prevRoute === "/app/snapshot";
                        localStorage.setItem("isRouteMode3", JSON.stringify(isRouteMode3));
                        navigate("/app/start-application");
                      }}
                    >
                      Start Application
                    </button>
                  </DropdownItem>
                  <DropdownItem className="d-flex gap-2 content_drop align-items-center">
                    <button
                      className="dash_button"
                      onClick={() => {
                        const prevRoute = localStorage.getItem("prevRoute");
                        // console.log("Previous Route before navigating:", prevRoute);
                        const isEditMode3 = prevRoute === "/app/snapshot";
                        localStorage.setItem("isEditMode3", JSON.stringify(isEditMode3));
                        navigate("/clinic/add-patient");
                      }}
                    >
                      Add Patient
                    </button>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
          </div>
          <div className="right_header d-flex justify-content-end">
            <div className="drop_block">
            <MultiSelectCheckbox
                className="all_columns_blk"
                options={isPatient ? columnOptions : columnApplicationOptions}
                selectedOptions={selectedOption}
                onChange={handleColumn}
                placeholder="All Columns"
              />
            </div>
            {listFilter !== "applications" && listFilter !== "apln-assigned-me" ?
            <DynamicFilterDropdown onFilterChange={applyPatientFilters} type="Patient" selectedFilters={selectedFilter} columnOptions={columnOptions} staffList={staffList} refetch={getPatientList}/>
            : <DynamicFilterDropdown onFilterChange={applyApplicationFilters} type="Application" selectedFilters={selectedFilter} staffList={staffList} columnOptions={columnApplicationOptions} refetch={getApplicationList}/>
             }
            <Search
              value={searchKey}
              onChange={(e) => handleSearch(e)}
              />
          </div>
        </div>
        <div className="horizontal_divider"></div>
        <div className="row m-0">
          <div className="col-lg-2 col-md-12 nav_side">
            <Nav vertical className="gap-2">
              <h4 className="main-views mt-2 mb-2">Patients</h4>
              <NavItem className={listFilter === "new" ? 'active' : ''}>
                <NavLink href="#" onClick={() =>{handleFilter("new");setSelectedFilter([]);}} className="d-flex justify-content-between dashbord_nav mb-2">
                  New Patients
                  <span>{countofList?.newPatient ? countofList?.newPatient : 0}</span>
                </NavLink>
              </NavItem>
              <NavItem className={listFilter === "assigned-me" ? 'active' : ''}>
                <NavLink href="#" onClick={() => {handleFilter("assigned-me");setSelectedFilter([]);}} className="d-flex justify-content-between dashbord_nav mb-2">
                  Assigned to me
                  <span>{countofList?.assignedMe ? countofList?.assignedMe : 0}</span>
                </NavLink>
              </NavItem>
              <NavItem className={listFilter === "ai-verified" ? 'active' : ''}>
                <NavLink onClick={() => {handleFilter("ai-verified");setSelectedFilter([]);}} href="#" className="d-flex justify-content-between dashbord_nav mb-2">
                  Medicaid Eligibility
                  <span>{countofList?.aiCare ? countofList?.aiCare : 0}</span>
                </NavLink>
              </NavItem>
              <h4 className="main-views mt-2 mb-2">Applications</h4>
              <NavItem className={listFilter === "applications" ? 'active' : ''}>
                <NavLink href="#" onClick={() => {handleFilter("applications");setSelectedFilter([]);}} className="d-flex justify-content-between dashbord_nav mb-2">
                  All applications
                  <span>{countofApplicationList?.allPatient ? countofApplicationList?.allPatient : 0}</span>
                </NavLink>
              </NavItem>
              <NavItem className={listFilter === "apln-assigned-me" ? 'active' : ''}>
                <NavLink href="#" onClick={() => {handleFilter("apln-assigned-me");setSelectedFilter([]);}} className="d-flex justify-content-between dashbord_nav mb-2">
                  Assigned to me
                  <span>{countofApplicationList?.assignedMe ? countofApplicationList?.assignedMe : 0}</span>
                </NavLink>
              </NavItem>
              <h4 className="main-views mt-2 mb-2 d-flex justify-content-between align-items-center">My Views</h4>
              {(listFilter !== "applications" && listFilter !== "apln-assigned-me" ?
                (patients?.filterList?.length > 0 ? patients.filterList : [])
                : (applicationList?.filterList?.length > 0 ? applicationList.filterList : [])
              ).map((filter) => (
              <NavItem className="d-flex justify-content-between align-items-center" key={filter?._id}>
                <NavLink
                  href="#"
                  className="d-flex justify-content-between dashbord_nav mb-2"
                  onClick={() => { handleFilterSelect(filter);}}
                >
                  {filter.title}
                </NavLink>
                <Dropdown
                  isOpen={dropdownState[filter._id] || false}
                  toggle={() => togglefour(filter._id)}
                  >
                  <DropdownToggle caret size="xl" className="filter_block_blk">
                    <i className="fa fa-ellipsis-v"></i>
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem
                      className="d-flex gap-2 drop_block_content align-items-center"
                      onClick={() => handleFilterDelete(filter._id)}
                    >
                      Delete View
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </NavItem>
            ))}
            </Nav>
          </div>{
            (listFilter !== "applications" && listFilter !== "apln-assigned-me" ) ?
             <>
              <div className="col-lg-10 col-md-12 table_space">
                <div className="table-responsive">
                  <table>
                    <thead>
                      <tr className="header_table">
                      <th className="p-0"></th>
                    {(selectedOption.length !== 0 && selectedOption.includes("patient_name")) && <th onClick={() => handleSort("name")}>Patient Name <i className='fas fa-sort'></i></th>}
                    {(selectedOption.length !== 0 && selectedOption.includes("medicaid_eligibility")) &&<th>Medicaid Eligibility</th>}
                    {(selectedOption.length !== 0 && selectedOption.includes("household_salary")) && <th>Annual Household Income</th>}
                    {(selectedOption.length !== 0 && selectedOption.includes("assigned_to")) && <th>Assigned To</th>}
                    {(selectedOption.length !== 0 && selectedOption.includes("state")) && <th>State</th>}
                    {(selectedOption.length !== 0 && selectedOption.includes("coverage")) && <th>Coverage</th>}
                    {(selectedOption.length !== 0 && selectedOption.includes("department_approval")) && <th>Department Approval</th>}
                    {(selectedOption.length !== 0 && selectedOption.includes("pregnant")) && <th>Pregnant</th>}
                    {(selectedOption.length !== 0 && selectedOption.includes("disable")) && <th>Disable</th>}
                    {(selectedOption.length !== 0 && selectedOption.includes("group_eligibility")) &&<th>Eligibility Group</th>}
                    {(selectedOption.length !== 0 && selectedOption.includes("discharged_status")) && <th>Discharged Status</th>}
                    {(selectedOption.length !== 0 && selectedOption.includes("stage")) && <th>DOA</th>}
                    {(selectedOption.length !== 0 && selectedOption.includes("household_members")) && <th>Household Members</th>}
                    <th></th>
                      </tr>
                    </thead>
                    {paginatedPatients?.length > 0 ? paginatedPatients?.map((patient, index) => (
                  <tbody key={patient?._id}>
                    <tr><td colSpan="9" height="5" className="bg_light"></td></tr>
                    <tr className={index % 2 === 0 ? 'first_block' : 'second_block'}>
                      <td className="check_in p-0 color_change" onClick={() => handleExpand(patient?._id)}><i className={expandedOrg.includes(patient?._id) ? 'fas fa-caret-down' : 'fas fa-caret-right'}></i></td>
                      {(selectedOption.length !== 0 && selectedOption.includes("patient_name")) && (
                        <td className="d-flex flex-column gap-2">
                          <Link
                            to="/clinic/patient-profile"
                            className="title_name"
                            state={{ patientData: patient?._id }}
                          >
                            {patient?.name?.text}
                          </Link>
                          {calculateAge(moment(patient?.birthDate).format("DD-MM-YYYY"))} | {patient?.gender} | {patient?.address?.state}
                          {patient?.archieve ? (
                            <button className="pending_blk" style={{ color: "red" }}>
                              Archived
                            </button>
                          ) : null}
                        </td>
                      )}
                      {(selectedOption.length !== 0 && selectedOption.includes("medicaid_eligibility")) && <td><button className={`btn_status ${patient?.houseHoldIncome === null ? "None" : patient?.system_ai_care === "Yes" || patient?.houseHoldIncome === 0 ? "yes" : patient?.system_ai_care === "No" ? "no" : ""}`}>{AI_CARE} : {patient?.houseHoldIncome === null ? "None" : patient?.system_ai_care === "Yes" || patient?.houseHoldIncome === 0 ? "Yes" : patient?.system_ai_care === "No" ? "No" : "None"}</button>
                        <br/>
                        {patient?.houseHoldIncome !== null && patient?.applied_fpl_percentage && patient?.eligibility_group_applied && patient?.applied_income_limit &&
                        <div className="poverty-limit">
                          <p>FPL : {patient?.applied_fpl_percentage} %</p>
                          <p>Group : {patient?.eligibility_group_applied}</p>
                          <p>Limit : {Math.round(patient.applied_income_limit)} USD</p>
                          </div>}
                          </td>}
                        {(selectedOption.length !== 0 && selectedOption.includes("household_salary")) && <td>
                          <TextInput
                            keyField={"householdIncome"}
                            required={false}
                            type="text"
                            value={
                              houseIncome[patient?._id] !== undefined
                                ? houseIncome[patient?._id]
                                : (patient?.houseHoldIncome !== undefined ? patient.houseHoldIncome : "")
                            }
                            onBlur={() =>
                              handleSaveClick(patient?._id, { houseHoldIncome: houseIncome[patient?._id] !== undefined ? houseIncome[patient?._id] : patient?.houseHoldIncome || 0 })
                            }
                            onChange={(e) => handleHouseIncomeChange(patient?._id, e.target.value)}
                          />
                          </td>}
                      {(selectedOption.length !== 0 && selectedOption.includes("assigned_to")) && <td>
                      <FormControl sx={{ m: 1, minWidth: 80 }} size="small">
                          <Select
                            labelId="demo-select-small-label"
                            id="demo-select-small"
                            value={patient?.staffId || '' }
                            onChange={(e) => handleStaffSelect(patient._id, e.target.value)} // Assign staff to this patient
                          >
                            <MenuItem value="">
                              <em>None </em>
                            </MenuItem>
                            {staffList?.map((option) => (
                              <MenuItem key={option.value} value={option.value}>
                                {option.label}
                              </MenuItem>
                            ))}
                          </Select>
                          </FormControl>
                        </td>}
                        {(selectedOption.length !== 0 && selectedOption.includes("state")) && <td>{patient?.address?.state}</td>}
                      {(selectedOption.length !== 0 && selectedOption.includes("coverage")) && <td>
                        <FormControl sx={{ m: 1, minWidth: 80 }} size="small">
                          <Select
                            labelId="demo-select-small-label"
                            id="demo-select-small"
                            value={patient?.coverage}
                            onChange={(e) => handleSaveClick(patient._id, {"coverage":e.target.value})} // Assign staff to this patient
                          >
                          {yesNoOptions?.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                        </FormControl></td>}
                      {(selectedOption.length !== 0 && selectedOption.includes("department_approval")) && <td>
                      <FormControl sx={{ m: 1, minWidth: 80 }} size="small">
                        <Select
                              labelId="demo-select-small-label"
                              id="demo-select-small"
                              value={patient?.departmentAprvlStatus}
                              onChange={(e) => handleSaveClick(patient._id, {"departmentAprvlStatus":e.target.value === "" ? null : e.target.value})}
                            >
                              <MenuItem value="">
                                <em>None </em>
                              </MenuItem>
                              {DepartmentOptions?.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                  {option.label}
                                </MenuItem>
                              ))}
                        </Select>
                        </FormControl></td>}
                          {(selectedOption.length !== 0 && selectedOption.includes("pregnant")) && (
                            <td>
                              {patient?.gender === "Male" ? (
                                <span style={{ margin: '8px', display: 'inline-block' }}>N/A</span>
                              ) : (
                                <FormControl sx={{ m: 1, minWidth: 80 }} size="small">
                                  <Select
                                    labelId="demo-select-small-label"
                                    id="demo-select-small"
                                    value={patient?.isPregnant}
                                    onChange={(e) =>
                                      handleSaveClick(patient._id, { isPregnant: e.target.value })
                                    }
                                  >
                                    {yesNoOptions?.map((option) => (
                                      <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              )}
                            </td>
                          )}
                          {(selectedOption.length !== 0 && selectedOption.includes("disable")) && <td>
                              <FormControl sx={{ m: 1, minWidth: 80 }} size="small">
                              <Select
                                labelId="demo-select-small-label"
                                id="demo-select-small"
                                value={patient?.isDisable}
                                onChange={(e) => handleSaveClick(patient._id, {"isDisable":e.target.value})} // Assign staff to this patient
                              >
                              {yesNoOptions?.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                  {option.label}
                                </MenuItem>
                              ))}
                            </Select>
                            </FormControl>
                          </td>}
                         {(selectedOption.length !== 0 && selectedOption.includes("group_eligibility")) && (
                          <td>
                            {(Array.isArray(patient?.medicaidElegibitlyGroup) && patient.medicaidElegibitlyGroup.length > 0)
                              ? patient.medicaidElegibitlyGroup.join(", ")
                              : " "}
                          </td>
                        )}
                        {(selectedOption.length !== 0 && selectedOption.includes("discharged_status")) && <th><FormControl sx={{ m: 1, minWidth: 80 }} size="small">
                          <Select
                            labelId="demo-select-small-label"
                            id="demo-select-small"
                            value={patient?.discharged_status}
                            onChange={(e) => handleSaveClick(patient._id, {"discharged_status":e.target.value === "" ? null : e.target.value})} // Assign staff to this patient
                          >
                          <MenuItem value="">
                            <em>None </em>
                          </MenuItem>
                          {yesNoOptions?.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                        </FormControl></th>}
                      {(selectedOption.length !== 0 && selectedOption.includes("stage")) && <td>{moment(patient?.doa).format("MM-DD-YYYY")}</td>}
                      {(selectedOption.length !== 0 && selectedOption.includes("household_members")) && (
                        <td className="d-flex flex-column gap-2 align-items-center">
                          <div>Size: {patient?.houseHoldSize || patient?.relationship?.length || 0}</div>
                          <div className="text-center d-flex flex-column">
                            {getRelationshipWithAges(patient?.relationship)}
                          </div>
                        </td>
                      )}
                      {(selectedOption.length !== 0 && selectedOption.includes("group_eligibility")) &&<td>
                        </td>}
                      <td>
                        <button onClick={() => { navigate("/clinic/patient-profile", { state: { patientData: patient?._id } }); }} style={{ background: "none" }} >
                          <Link className="d-flex flex-column gap-1 align-items-center">
                            <i className="fa fa-external-link"></i>View Details
                          </Link>
                        </button>
                      </td>
                    </tr>
                    {expandedOrg.includes(patient?._id) && <tr className="first_block">
                      <td colSpan={13}>
                        <div className="patient_summery_blockk px-3">
                          <h5 className="summary_block mb-4">Patient Summary</h5>
                          <div className="d-flex data_patient align-items-center">
                            <div className="d-flex align-items-center flex-column">
                              <img className="patient_profile_summary m-0" src={patient?.profile_image ? patient?.profile_image : noProfileImg} alt="patient_profile" />
                              <button className="view_summery" onClick={() => { navigate("/clinic/add-patient", { state: { patientDetails: patient } }); }}>Edit Details</button>
                            </div>
                            <div className="d-flex gap-3 flex-column">
                              <div className="d-flex data_patient_blk gap-5">
                                <div className="d-flex data_patient_blk gap-5 size_data">
                                  <p className="data_summary">Phone Number : <span>{patient?.telecom[1]?.value}</span></p>
                                  <p className="data_summary">Emergency Contact : <span>{patient?.emergencyContacts?.phone}</span></p>
                                </div>
                                {/* <button className="start_blk" disabled={!patient?.staffId || patient?.system_ai_care === "No" || patient?.system_ai_care === "None" || patient?.archieve === true} onClick={()=>{navigate("/app/start-application", { state: { patientDetails: patient } });}}>Start Application</button> */}
                                  <button
                                    className="start_blk"
                                    disabled={
                                      !patient?.staffId ||
                                      patient?.system_ai_care === "No" ||
                                      patient?.system_ai_care === "None" ||
                                      patient?.archieve === true ||
                                      patient?.applications?.some(app => app.status === "InProcess")
                                    }
                                    onClick={() => {
                                      navigate("/app/start-application", { state: { patientDetails: patient } });
                                    }}
                                  >
                                    Start Application
                                  </button>
                                  {(
                                    !patient?.staffId ||
                                    patient?.system_ai_care === "No" ||
                                    patient?.system_ai_care === "None" ||
                                    patient?.archieve === true ||
                                    patient?.applications?.some(app => app.status === "InProcess")
                                  ) && (
                                    <div className="disabled-reason" style={{ marginTop: "10px", color: "black", fontSize: "12px" }}>
                                      {!patient?.staffId && <p>To start application assign patient to staff member.</p>}
                                      {patient?.system_ai_care === "No" && <p>Application cannot be initiated. Patient is not eligible for Medicaid</p>}
                                      {patient?.system_ai_care === "None" && <p>Application cannot be initiated. Patient is not eligible for Medicaid</p>}
                                      {patient?.archieve === true && <p>Patient is Archived</p>}
                                      {patient?.applications?.some(app => app.status === "InProcess") && <p>Application cannot be initiated. Patient application already is In-Process</p>}
                                    </div>
                                  )}
                              </div>
                              <div className="d-flex data_patient_blk gap-5">
                                <div className="d-flex data_patient_blk gap-5 size_data">
                                  <p className="data_summary">Emergency Name : <span>{patient?.emergencyContacts?.name}</span></p>
                                  <p className="data_summary">Primary Coverage : <span>{patient?.insuranceDetails?.company}</span></p>
                                  <p className="data_summary">Secondary Coverage : <span>{patient?.insuranceDetails?.alternateCompany}</span></p>
                                </div>
                                <button className="archeive_blk" onClick={() => handleSaveClick(patient._id, {"archieve": !patient?.archieve})}>{patient?.archieve ? "UnArchieve" : "Archieve"}</button>
                              </div>
                              <div className="d-flex data_patient_blk gap-5">
                                <div className="d-flex data_patient_blk gap-5 size_data">
                                  <p className="data_summary">Medicaid Enrollment Status : <span>{patient?.medicaidEnrollmentStatus}</span></p>
                                  <p className="data_summary">Medicaid Enrollment Date : <span>{moment().format("MM-DD-YYYY")}</span></p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="note_block mt-3">
                            <p className="data_summary">Note :</p>
                            <div className="d-flex align-items-center gap-2">
                              <Form className="text_block">
                                <Input
                                  id="exampleText"
                                  name="text"
                                  type="textarea"
                                  className="text_area_blk"
                                  value={editingPatient[patient._id] ? patientNote[patient._id] : patient?.patientNote || ''}
                                  onClick={() => handleEditClick(patient._id)} // Enable editing when clicking on the input
                                  onChange={(e) => handleNoteChange(patient._id, e.target.value)}
                                />
                              </Form>
                              <div className="d-flex gap-3">
                                {editingPatient[patient._id] ? (
                                  <i
                                    className="fa fa-floppy-disk"
                                    onClick={() => handleSaveClick(patient._id, { patientNote: patientNote[patient._id] })}
                                    style={{ cursor: 'pointer' }}
                                  ></i>
                                ) : (
                                  <i
                                    className="fa fa-edit"
                                    onClick={() => handleEditClick(patient._id)}
                                    style={{ cursor: 'pointer' }}
                                  ></i>
                                )}
                                {patient?.patientNote ? (
                                  <i
                                    className="fas fa-trash-alt"
                                    onClick={() => handleDeleteClick(patient._id, { patientNote: '' })}
                                    style={{ cursor: 'pointer' }}
                                  ></i>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>}
                    <tr><td colSpan="9" height="5" className="bg_light"></td></tr>
                  </tbody>
                )) : <tr><td colSpan={10}><p className="text-center">No Data Found</p></td></tr>}
                  </table>
                </div>
                <CustomPagination tableData={filteredPatients?.items} totalPages={filteredPatients?.totalPages} totalRows={filteredPatients?.length} rowsPerPage={ITEMS_PER_PAGE} page={currentPage} handlePage={handlePagination} />
              </div>
             </>
              :<>
            <div className="col-lg-10 col-md-12 table_space">
            <div className="table-responsive">
              <table>
                <thead>
                  <tr className="header_table">
                    <th className="p-0"></th>
                    {selectedOption.length !== 0 && selectedOption.includes("title") && (<th>
                      Application Title{" "}
                      <i
                        className="fas fa-sort"
                        onClick={() => handleSort("title")}
                      ></i>
                    </th>)}
                    {selectedOption.length !== 0 && selectedOption.includes("patient_name") && (
                      <th>Patient Name</th>)}
                    {selectedOption.length !== 0 && selectedOption.includes("type") && (
                      <th>Application Type</th>
                    )}
                    {selectedOption.length !== 0 && selectedOption.includes("created_at") && (
                      <th>Created at</th>
                    )}
                    {selectedOption.length !== 0 && selectedOption.includes("assigned_to") && (
                      <th>Assigned To</th>
                    )}
                    {selectedOption.length !== 0 && selectedOption.includes("status") && (
                      <th>Status</th>
                    )}
                    {selectedOption.length !== 0 && selectedOption.includes("state") && (
                      <th>Resident State</th>
                    )}
                    {selectedOption.length !== 0 && selectedOption.includes("group_eligibility") && (
                      <th>Eligibility Group</th>
                    )}
                    <th></th>
                  </tr>
                </thead>
                      {paginatedApplications?.length > 0 ? (
                        paginatedApplications?.map((apln, index) => {
                          const activeStepIndex =
                            apln?.stages?.some((stage) => stage.status === "NotApproved")
                              ? apln.stages.findIndex((stage) => stage.status === "NotApproved")
                              : apln.stages.every((stage) => stage.status === "Approved")
                                ? apln.stages.length
                                : apln.stages.findIndex((stage) => stage.status === "InProcess") !== -1
                                  ? apln.stages.findIndex((stage) => stage.status === "InProcess")
                                  : apln.stages.findIndex((stage) => stage.status === "NotStarted") !== -1
                                    ? apln.stages.findIndex((stage) => stage.status === "NotStarted")
                                    : apln.stages.length - 1;

                          const activeStepStatus =
                            apln?.stages.find(step => step.status === "NotApproved")?.status ||
                            apln?.stages.find(step => step.status === "InProcess")?.status ||
                            apln?.stages.find(step => step.status === "NotStarted")?.status;

                          const activeColor = activeStepStatus === "NotApproved"
                            ? "#E44545"
                            : activeStepStatus === "InProcess"
                              ? "#ECB800"
                              : activeStepStatus === "NotStarted"
                                ? "#8B8D91"
                                : "#339900";

                          const activeTitleColor = activeStepStatus === "NotApproved"
                            ? "#E44545"
                            : activeStepStatus === "InProcess"
                              ? "#ECB800"
                              : activeStepStatus === "NotStarted"
                                ? "#8B8D91"
                                : "#339900";

                          const activeBarColor = activeStepStatus === "NotApproved"
                            ? "#E44545"
                            : activeStepStatus === "InProcess"
                              ? "#ECB800"
                              : activeStepStatus === "NotStarted"
                                ? "#8B8D91"
                                : "#339900";

                          return (
                            <tbody key={apln?._id}>
                              <tr>
                                <td colSpan={9} height={5} className="bg_light"></td>
                              </tr>
                              <tr className={index % 2 === 0 ? 'first_block' : 'second_block'}>
                                <td
                                  className="check_in p-2"
                                  onClick={() => handleExpand(apln?._id)}
                                >
                                  <i
                                    className={
                                      expandedOrg.includes(apln?._id)
                                        ? "fas fa-caret-down"
                                        : "fas fa-caret-right"
                                    }
                                  ></i>
                                </td>
                                {selectedOption.length !== 0 &&
                                  selectedOption.includes("title") && (
                                    <td className="check_in">
                                        <Link to={"/app/application-detail"} className="d-flex flex-column gap-1" state={{ applicationData: apln }} >
                                        {apln?.title}
                                        <button className="admin_application_container pending_blk">
                                          Pending Tasks: 03
                                        </button>
                                      </Link>
                                    </td>
                                  )}
                                {selectedOption?.length !== 0 &&
                                  selectedOption?.includes("patient_name") && (
                                    <td className="d-flex flex-column gap-2">
                                      <Link
                                        to="/clinic/patient-profile"
                                        className="title_name"
                                        state={{ patientData: apln?.patientData?._id }}
                                        >
                                        {decryptData(apln?.patientData?.name[0].text)}
                                      </Link>
                                      {(() => {
                                        const birthDate = decryptData(
                                          apln?.patientData?.birthDate
                                        );
                                        const formattedBirthDate = birthDate
                                          ? moment(birthDate).format("DD-MM-YYYY")
                                          : "Unknown Date";
                                        const gender =
                                          decryptData(apln?.patientData?.gender) ||
                                          "Unknown Gender";
                                        const age = formattedBirthDate
                                          ? calculateAge(formattedBirthDate)
                                          : "Unknown Age";

                                        return `${age} | ${gender} | 110334343`;
                                      })()}
                                    </td>
                                  )}
                                {selectedOption.length !== 0 &&
                                  selectedOption.includes("type") && (
                                    <td>Enrollment</td>
                                  )}
                                {selectedOption.length !== 0 &&
                                  selectedOption.includes("created_at") && (
                                    <td>
                                      {moment(apln?.createdAt).format("MM-DD-YYYY")}
                                    </td>
                                  )}
                                {selectedOption.length !== 0 &&
                                  selectedOption.includes("assigned_to") && (
                                    <td>
                                      <Select
                                        label="Select Staff"
                                        placeholder="Select"
                                        value={apln?.consultantUser?._id} // Get selected staff for the patient
                                        onChange={(e) =>
                                          handleUpdate(apln._id, { consultantId: e.target.value })
                                        } // Assign staff to this patient
                                      >
                                        <MenuItem disabled value="">
                                          <em>Select Staff</em>
                                        </MenuItem>
                                        {staffList?.map((option) => (
                                          <MenuItem
                                            key={option.value}
                                            value={option.value}
                                          >
                                            {option.label}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </td>
                                  )}
                                {selectedOption.length !== 0 &&
                                  selectedOption.includes("status") && (
                                    <td>
                                      {apln?.status}
                                    </td>
                                  )}
                                {selectedOption.length !== 0 &&
                                  selectedOption.includes("state") && <td>{decryptData(apln?.patientData?.address[0].state)}</td>}
                                  {(selectedOption.length !== 0 && selectedOption.includes("group_eligibility")) && (
                                    <td>
                                      {(Array.isArray(apln?.patientData?.medicaidElegibitlyGroup) && apln?.patientData?.medicaidElegibitlyGroup.length > 0)
                                        ? apln?.patientData?.medicaidElegibitlyGroup.join(", ")
                                        : " "}
                                    </td>
                                  )}
                                <td>
                                  <Link to={"/app/application-detail"} state={{ applicationData: apln }} className="d-flex flex-column gap-1 align-items-center"><i className="fa fa-external-link"></i>View Details</Link>
                                </td>
                              </tr>
                              {expandedOrg.includes(apln?._id) && (
                                <tr className="table_collapse_row ">
                                  <td colSpan={11}>
                                    <div className="description_application_block first">
                                      <div className="tracker">
                                        <div>
                                          <Stepper
                                            activeColor={activeColor}
                                            defaultColor="#8B8D91"
                                            completeColor="#339900"
                                            activeTitleColor={activeTitleColor}
                                            completeTitleColor="#339900"
                                            activeBarColor={activeBarColor}
                                            completeBarColor="#339900"
                                            steps={apln?.stages.map((step) => ({
                                              title: (
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                  <span>{step?.name}</span>
                                                  {step?.status === "InProcess" && (
                                                    <button
                                                      style={{
                                                        marginLeft: '10px',
                                                        backgroundColor: '#ECB800',
                                                        color: '#fff',
                                                        border: 'none',
                                                        borderRadius: '4px',
                                                        padding: '4px 8px',
                                                        cursor: 'pointer'
                                                      }}
                                                    >
                                                      Current Stage
                                                    </button>
                                                  )}
                                                  {step?.status === "NotApproved" && (
                                                    <button
                                                      style={{
                                                        marginLeft: "10px",
                                                        backgroundColor: "#E44545", // Red for rejected
                                                        color: "#fff",
                                                        border: "none",
                                                        borderRadius: "4px",
                                                        padding: "4px 8px",
                                                        cursor: "pointer"
                                                      }}
                                                    >
                                                      Not Approved
                                                    </button>
                                                  )}
                                                </div>
                                              )
                                            }))}
                                            activeStep={activeStepIndex}
                                          />
                                        </div>
                                      </div>
                                      <h6 className="title_description">Application Summary</h6>
                              <p className="desc_application mb-3">
                                <span>Application : </span>
                                {decryptData(apln?.patientData?.name[0].text)} | {apln?.eligibilityCriteria?.age} | {apln?.eligibilityCriteria?.stateOfResidence?.label} - {apln?.title}
                              </p>
                              <div className="d-flex justify-content-between align-items-start">
                                <div className="left_desc_group">
                                  <div className="d-flex align-items-start gap-2 mb-3">
                                    <p className="desc_application">
                                      <span>Consultant :  </span>
                                    </p>
                                    <p className="desc_application">
                                      {apln.consultantUser ? (
                                        <span>{apln.consultantUser?.firstName + " " + apln.consultantUser?.lastName}</span>
                                      ) : (
                                        <span>No Consultant assigned.</span>
                                      )}
                                      <br />
                                      <i className="fa fa-envelope"></i> {apln?.consultantUser?.email}
                                    </p>
                                  </div>
                                  <div className="d-flex align-items-center gap-2 mb-3">
                                    <p className="desc_application">
                                      <span>Active Days : </span>
                                    </p>
                                    <p className="desc_application">45 days</p>
                                  </div>
                                </div>
                                <div className="right_desc_group">
                                  <div className="d-flex align-items-center gap-2">
                                    <div className="d-flex align-items-center gap-2 mb-3 flex-wrap">
                                      <p className="desc_application">
                                        <span>Medicaid Enrollment Status : </span>
                                      </p>
                                      <p className="desc_application">
                                        {apln?.patientData?.medicaidEnrollmentStatus}
                                      </p>
                                    </div>
                                    {apln?.patientData?.medicaidEnrollmentStatus === "Denied" && (
                                      <>
                                        <div className="d-flex align-items-center gap-2 mb-3 flex-wrap">
                                          <p className="desc_application">
                                            <span>Medicaid Denied Code : </span>
                                          </p>
                                          <p className="desc_application">
                                            {apln?.patientData?.medicaidDeniedCode}
                                          </p>
                                        </div>
                                        <div className="d-flex align-items-center gap-2 mb-3 flex-wrap">
                                          <p className="desc_application">
                                            <span>Medicaid Enrollment Reason : </span>
                                          </p>
                                          <p className="desc_application">
                                            {apln?.patientData?.medicaidDeniedReason && decryptData(apln?.patientData?.medicaidDeniedReason)}
                                          </p>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                  <div className="d-flex align-items-center gap-2 mb-3 flex-wrap">
                                    <p className="desc_application">
                                      <span>Latest Update : </span>
                                    </p>
                                    <p className="desc_application">{apln?.latestUpdate}</p>
                                  </div>
                                  <div className="d-flex align-items-center gap-2 mb-3 flex-wrap">
                                    <p className="desc_application">
                                      <span>Application Notes : </span>
                                    </p>
                                  </div>
                                  <div className="d-flex gap-3 mb-3 align-items-center">
                                    <Form className="text_block">
                                      <Input
                                        id="exampleText"
                                        name="text"
                                        type="textarea"
                                        className="text_area_blk"
                                        value={applicationNote[apln._id] ?? apln?.latestCaseNote ?? ''}
                                        onChange={(e) => {
                                          handleNoteChange(apln._id, e.target.value);
                                        }}
                                        onClick={() => handleEditClick(apln._id)}
                                      />
                                    </Form>
                                    <div className="d-flex gap-3">
                                      {(applicationNote[apln._id] !== undefined && applicationNote[apln._id] !== apln?.latestCaseNote) ? (
                                        <i
                                          className="fa fa-floppy-disk"
                                          onClick={() => handleUpdate(apln._id, { latestCaseNote: applicationNote[apln._id] }, apln?.patientData?._id)}
                                          style={{ cursor: 'pointer' }}
                                        />
                                      ) : (
                                        <i
                                          className="fa fa-edit"
                                          onClick={() => handleEditClick(apln._id)}
                                          style={{ cursor: 'pointer' }}
                                        />
                                      )}
                                      {apln?.latestCaseNote !== "" && (
                                        <i
                                          className="fas fa-trash-alt"
                                          style={{ cursor: 'pointer' }}
                                          onClick={() => handleDeleteClick(apln._id, { latestCaseNote: "" })}
                                        />
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </tbody>);
                        })
                      ) : (
                        <tr>
                          <td colSpan={10}>
                            <p className="text-center">No Data Found</p>
                          </td>
                        </tr>
                      )}
              </table>
            </div>
            <div className="paginator_block">
            <CustomPagination
              tableData={listFilter !== "applications" && listFilter !== "apln-assigned-me"
                ? filteredPatients
                : filteredApplications?.items}
              totalPages={listFilter !== "applications" && listFilter !== "apln-assigned-me"
                ? patients?.totalPages
                : filteredApplications?.totalPages}
              totalRows={listFilter !== "applications" && listFilter !== "apln-assigned-me"
                ? filteredPatients?.length
                : filteredApplications?.length}
              rowsPerPage={ITEMS_PER_PAGE}
              page={currentPage}
              handlePage={handlePagination}
            />
            </div>
          </div>
            </>
          }
        </div>
      </div>
    </>
  );
}

snapshot.propTypes = {
  direction: PropTypes.oneOf([20, 10, 20, 20])
};

export default snapshot;
